import { SectionTitle } from "../global/SectionTitle"
import { FeaturedTexts } from "./new-arrival-section/FeaturedTexts"
import "./newArrivalSection.css"

export function NewArrivalSection(){
    return (
        <div className="new-arrival-section">
            <SectionTitle title="Featured" />
            <p className="section-title mt-3">New Arrival</p>

            <div className="d-flex featured-products mt-5 gap-1 lg-row">
                <div className="featured1">
                    <div className="d-flex flex-column justify-content-end h-100 bg-black rounded-1">
                        <div className="w-50 mx-4 my-3 ps-1 pe-3">
                            <FeaturedTexts
                                heading="Playstation 5"
                                description="Black and White version of the PS5 coming out on sale."
                            />
                        </div>  
                    </div>
                </div>
                <div className="featured2">
                    <div className="d-flex flex-column h-100 gap-1">
                        <div className="featured2-1 h-50">
                            <div className="d-flex flex-column justify-content-end h-100 rounded-1">
                                <div className="w-50 mx-4 my-3 ps-1 pe-3">
                                    <FeaturedTexts
                                        heading="Women's Collections"
                                        description="Featured woman collections that give you another vibe."
                                    />  
                                </div>
                            </div>
                            
                        </div>
                        <div className="d-flex featured2-2 h-50 gap-1">
                            <div className="featured2-2-1 bg-black position-relative w-50 overflow-hidden rounded-1">
                                <div
                                    className="position-absolute start-50 top-50 glowing-circle rounded-circle">
                                </div>
                                <div className="d-flex flex-column justify-content-end w-100 position-absolute featured2-2-1-image">
                                    <div className="w-75 ms-4 position-absolute">
                                        <FeaturedTexts
                                            heading="Speakers"
                                            description="Amazon wireless speakers"
                                        />  
                                    </div>
                                </div>
                            </div>
                            <div className="featured2-2-2 bg-black position-relative w-50 overflow-hidden rounded-1">
                                <div
                                    className="position-absolute start-50 top-50 glowing-circle rounded-circle">
                                </div>
                                <div className="d-flex flex-column justify-content-end w-100 position-absolute featured2-2-2-image">
                                    <div className="w-75 ms-4 position-absolute">
                                        <FeaturedTexts
                                            heading="Perfume"
                                            description="GUCCI INTENSE OUD EDP"
                                        />  
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}